import angular from 'angular';

let InsuranceStateDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Insurance) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.isEdit = false;
  $ctrl.state;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    edit,
    create

  });

  activate();

  function activate() {
    clearForm();
    $ctrl.state_id = null
    loadResource($ctrl.id);
  }

  function clearForm(form) {

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function create(resource) {
    console.log("create", resource)
    const uf = resource.uf;
    $state.go('insurance.ccreate', {uf});
  }
  function edit(resource) {
    console.log("resource", resource)
    const uf = $ctrl.state.uf, id = resource.id;
    localStorage.setItem('cityInsurance', JSON.stringify(resource))
    $state.go('insurance.cedit', {uf, id});
  }
  function handleDelete(card, event) {
    let confirmMessage = 'card-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Insurance
          .destroy(card)
          .then(response => {
            Toast.success($filter('translate')('card-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('card.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, state) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }
    state.save = $ctrl.id != null && $ctrl.id !== '';
    save(state);
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';
      const resource = JSON.parse(localStorage.getItem('stateInsurance'));
      $ctrl.isEdit = true;
      $ctrl.state = {
        id: resource.id,
        uf: resource.sigla,
        description: resource.descricao
      };
      Insurance.listCities(resource.sigla)
        .then(cities => {
          $ctrl.resources = cities;
          $ctrl.loadingCities = false;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:', err);
          $ctrl.loadingCities = false;
        });

    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(card) {
    $ctrl.saving = true;

    Insurance
      .saveState(card)
      .then(response => {
        Toast.success($filter('translate')('insurance-state-detail-save-success'));
        $ctrl.card = response;
        $ctrl.saving = false;
        $state.go('insurance.state');
      })
      .catch(err => {
        if (typeof err.data == "string") {
          Toast.error($filter('translate')(err.data));
        } else {
          let defaultErrMsg = 'common-server-error';
          let fourONineMsg = 'card-detail-409-error';
          let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
          Toast.error($filter('translate')(message));
        }
        console.log('err:', err);
        $ctrl.saving = false;
      });
  }
}

InsuranceStateDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];

export default InsuranceStateDetailController;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-state-detail.controller.js